import { FunctionComponent } from 'react';
import { QueryForm } from './dataqueries/QueryForm';
import { QueryStatusDisplay } from './dataqueries/QueryStatusDisplay';
import { DataQueryHookResult, useTableDataQuery } from './dataqueries/useTableDataQuery';
import { EmptyResultMessage } from './resulttable/EmptyResultMessage';
import { ResultTable } from './resulttable/ResultTable';
import { FormattedMessage } from 'react-intl';

export const OobInspector: FunctionComponent = () => {
    const { processQuery, queryId, isProcessing, queryFailed, results } = useTableDataQuery();
    return (
        <>
            <QueryForm isProcessing={isProcessing} processQuery={processQuery} />
            <QueryStatusDisplay isProcessing={isProcessing} queryId={queryId} />
            {queryFailed ? <QueryFailedErrorMessage /> : <QueryResults results={results} />}
        </>
    );
};

const QueryResults: FunctionComponent<Pick<DataQueryHookResult, 'results'>> = ({ results }) => {
    if (results === undefined) {
        return <></>;
    }

    return results.items.length === 0 ? (
        <EmptyResultMessage />
    ) : (
        <ResultTable items={results.items} hasMore={results.limitExceeded} />
    );
};

const QueryFailedErrorMessage: FunctionComponent = () => {
    return (
        <div className="width-100pct display-flex justify-content-center">
            <div className="width-800-md width-600-sm width-100pct-ls width-100pct-xs alert alert-danger">
                <div className="display-flex gap-10">
                    <span className="text-color-danger text-size-h4 rioglyph rioglyph rioglyph-error-sign" />
                    <div>
                        <strong className="text-size-16">
                            <FormattedMessage id="outboundOrderBook.inspector.dataquery.failed.title" />
                        </strong>
                        <div className="margin-y-5">
                            <FormattedMessage id="outboundOrderBook.inspector.dataquery.failed.content" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
